export const CREATE_BRANCH = 'common@create-branch';
export const DELETE_BRANCH = 'common@delete-branch';
export const UPDATE_BRANCH = 'common@update-branch';